import { useEffect } from "react";
import { error, info, processNotify, success, warning, clear } from "./notifyUserUtility";

interface NotifyUserProps {
	pathUrl?: string;
	errors?: string[];
	infos?: string[];
	successes?: string[];
	warnings?: string[];
	setErrors?: (val: string[]) => void;
	setInfos?: (val: string[]) => void;
	setSuccesses?: (val: string[]) => void;
	setWarnings?: (val: string[]) => void;
}

export const NotifyUser = ({ pathUrl, errors, infos, successes, warnings, setErrors, setInfos, setSuccesses, setWarnings }: NotifyUserProps): null => {
	useEffect(() => {
		processNotify(errors, error, setErrors);
	}, [errors, setErrors]);

	useEffect(() => {
		processNotify(infos, info, setInfos);
	}, [infos, setInfos]);

	useEffect(() => {
		processNotify(successes, success, setSuccesses);
	}, [successes, setSuccesses]);

	useEffect(() => {
		processNotify(warnings, warning, setWarnings);
	}, [warnings, setWarnings]);

	useEffect(() => {
		clear(true);
	}, [pathUrl]);

	return null;
};
